<template>
  <div>
    <HospitalChidSearch :active="active" @query="queryList" @newBtnFun="toNew" @newChecked="newChecked"></HospitalChidSearch>
    <el-table :data="tableData" v-loading="loading" style="width: 100%"  align="center" height='calc(100vh - 285px)'>
      <el-table-column key="helpId" prop="helpId" width="145" label="救助编号" fixed="left">
        <template slot-scope="scope">
          <span class="link" @click="openDetail(scope.row)">{{
            scope.row.helpId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column key="submitTime" width="100" label="申请时间" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.submitTime ? parseTime(scope.row.submitTime, '{y}-{m}-{d}') : '-' }}
        </template>
      </el-table-column>
      <el-table-column key="childName" prop="childName" width="110" label="患儿姓名" fixed="left">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="hospitalName" v-if="isHospital==='false'"   width="140"   label="救助医院">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="diseasesNameSet" prop="diseasesNameSet" label="病种">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.diseasesNameSet"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="curStages" v-if="active == 'rollback'" prop="curStages"  width="70" label="期次">
        <template slot-scope="scope">
          {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-')) }}
        </template>
      </el-table-column>
      <el-table-column key="birthday" width="100" label="出生日期">
        <template v-slot="scope">
          {{ parseTime(scope.row.birthday, '{y}-{m}-{d}') }}
        </template>
      </el-table-column>
      <el-table-column key="sexText" prop="sexText" width="50" label="性别">
      </el-table-column>
      <el-table-column key="provinceText" width="120" label="户口所在地">
        <template slot-scope="scope">
          <TableCellWordBreak :content="(scope.row.provinceText || '') + (scope.row.cityText || '')"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="idNumber" prop="idNumber" width="170" label="身份证号">
        <template slot-scope="scope">
          {{ scope.row.hasIdNumber != 1 ? "-" : scope.row.idNumber }}
        </template>
      </el-table-column>
      <el-table-column key="nationText" width="80" prop="nationText" label="民族" class="float-left">
      </el-table-column>
      <!-- <el-table-column width="170" prop="guardIdNumber" label="监护人身份证号">
      </el-table-column> -->
      <el-table-column key="apprStatusText" prop="apprStatusText" width="80" label="救助状态">
        <template slot-scope="scope">
          <span v-if="scope.row.apprStatus == '5'">审核中</span>
          <span v-else :class="scope.row.apprStatus == 3 ? 'warning-text' : ''">{{scope.row.apprStatusText || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column key="apprTime" width="100" label="审核时间">
        <template slot-scope="scope">
          <span v-if="scope.row.apprStatus == 5">-</span>
          <span v-else>
            {{ scope.row.apprTime ? parseTime(scope.row.apprTime, '{y}-{m}-{d}') : '-' }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <Pageination @sizeChange="handleSizeChange" @currentChange="handleCurrentChange"
      :currentPage.sync="queryForm.pageNO" :total="total">
    </Pageination>
    <HelpDetailDialog
      v-if="detailJzDialog && detailData.curStages > 1"
      :visible="detailJzDialog"
      dataMode="reset"
      :title="患儿代申请"
      :belongProject="detailData.initialProject"
      :outlayId="detailData.outlayId"
      :helpId="detailData.helpId"
      :helpData="detailData"
      @success="queryList"
      @close="detailJzDialog = false">
    </HelpDetailDialog>
    <el-dialog title="患儿代申请" v-else-if="detailJzDialog" :visible.sync="detailJzDialog" @close='closeSubmit'
      width="1300px">
      <div v-if="detailData.apprStatus == 0 || detailData.apprStatus == 4 " style="text-align: right; padding: 0 16px 16px 0; background: white;">
         <span style="align-items: center" v-if="outherInfo == 'outherHospitalExist'">
                <img src="/static/err-icon.png" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" alt="" />
                <span style="display: inline-block;vertical-align: middle;color: #dc243e;">患儿已在其他医院注册，请联系项目经理</span>
         </span>
        <span style="align-items: center" v-if="outherInfo == 'currentHospitalInfoExist'">
                <img src="/static/err-icon.png" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" alt="" />
                <span style="display: inline-block;vertical-align: middle;color: #dc243e;">患儿已存在，请前往注册页面继续完善患儿信息</span>
         </span>
        <span style="align-items: center" v-if="outherInfo == 'similarChildExist'">
                <img src="/static/err-icon.png" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" alt="" />
                <span style="display: inline-block;vertical-align: middle;color: #dc243e;">存在基础信息重复患儿，请联系项目经理</span>
         </span>
        <span style="align-items: center" v-if="outherInfo == 'similarChildNocheckExist'">
                <img src="/static/err-icon.png" style="width: 20px;height: 20px;display: inline-block;vertical-align: middle;" alt="" />
                <span style="display: inline-block;vertical-align: middle;color: #dc243e;">存在基础信息重复且未审核患儿，请联系项目经理</span>
         </span>
        <el-button :loading="btnLoading" type="primary" icon="el-icon-s-release" size="small"
                  @click="saveData"  :disabled="(dialogActiveName == 'apprHistory' || checkSimalar == 'checked')">暂存</el-button>
        <el-button :loading="btnLoading" type="primary" icon="el-icon-success" size="small"
                  @click="submitConfrim"  :disabled="(dialogActiveName == 'apprHistory' || checkSimalar == 'checked')">提交</el-button>
      </div>
      <div v-if="detailData.apprStatus == 0" style="padding: 16px;">
        <HospitalChildInfo
          ref="hospitalChild"
          @checkSimalar="getcheckSimalar"
          :dataMode="dataMode"
          :formData="detailData"
          :helpId="detailData.helpId"
          :helpReqId="detailData.helpReqId"
          :belongProject="detailData.initialProject"
          @detailDataNew="detailDataNew"
          @beforeSave="btnLoading = true"
          @complete="btnLoading = false"
          @back="closeChilddDetail">
        </HospitalChildInfo>
      </div>
      <el-tabs v-else v-model="dialogActiveName">
        <el-tab-pane label="病历信息/家庭情况" name="caseInfo">
          <HospitalChildInfo
            v-if="dialogActiveName == 'caseInfo'"
            ref="hospitalChild"
            :dataMode="dataMode"
            :formData="detailData"
            :helpId="detailData.helpId"
            :helpReqId="detailData.helpReqId"
            :belongProject="detailData.initialProject"
            @back="closeChilddDetail">
          </HospitalChildInfo>
        </el-tab-pane>
        <el-tab-pane label="审核记录" name="apprHistory">
          <HospitalChildHistory v-if="dialogActiveName == 'apprHistory'" :helpId="detailData.helpId"
            :helpReqId="detailData.helpReqId">
          </HospitalChildHistory>
        </el-tab-pane>

      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getHelpStagesApi,
    getDataListByCondFq,
    getDataListByCond
  } from "@/util/api";
  import Pageination from '@/components/business/Pageination'
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  import dialogPanel from "@/components/business/dialogPanel";
  import HelpDetailDialog from '../view/HelpDetailDialog'
  import HospitalChidSearch from "./HospitalChidSearch";
  import HospitalChildInfo from './HospitalChildInfo'
  import HospitalChildHistory from './HospitalChildHistory'

  export default {
    components: {
      Pageination,
      TableCellWordBreak,
      HospitalChidSearch,
      HospitalChildInfo,
      HelpDetailDialog,
      HospitalChildHistory,
      dialogPanel,
    },
    props: {
      active: String,
    },
    data() {
      return {
        detailJzDialog: false,
        loading: true,
        isHospital:'false',
        btnLoading: false,
        detailData: {},
        dataMode: 'modify',
        dialogActiveName: 'caseInfo',
        queryForm: {
          searchCond: {},
          orderBy: "createAt desc",
          pageNO: 1,
          pageSize: 10,
        },
        total: 0,
        tableData: [],
        checkSimalar:"11",
        outherInfo:""
      };
    },
    created() {
        this.isHospital = window.localStorage.getItem("hospAccount")
        this.queryList();
    },
    methods: {
      // 关闭详情页
      closeChilddDetail() {
        this.detailJzDialog = false;
        this.queryList();
      },
      //详情
      openDetail(obj) {
        this.dataMode = 'modify';
        this.detailData = obj;
        this.detailJzDialog = true;
        //按钮放开
        this.newChecked();
      },
      //分页
      handleSizeChange(val) {
        this.queryForm.pageSize = val;
        this.queryList();
      },
      handleCurrentChange(val) {
        this.queryForm.pageNO = val;
        this.queryList();
      },
      toNew() {
        this.dataMode = 'add';
        this.detailData = {
          apprStatus: 0,
          apprStatusText: '未提交'
        };
        this.detailJzDialog = true;
        // this.$router.push("/child/hospital/add");
      },
      queryList(params) {
        this.queryForm = Object.assign(this.queryForm, params || {});
        let req = null;
        if (this.active == 'todo') {
          this.queryForm.searchCond["reqMode"] = 2;
          req = getDataListByCond({
            ...this.queryForm,
            searchCond: {
              ...this.queryForm.searchCond,
              apprStatus: this.queryForm.searchCond.apprStatus == 1 ? '1,5' : this.queryForm.searchCond.apprStatus
            }
          });
        } else if (this.active == 'rollback') {
          this.queryForm.searchCond["apprStatus"] = '4';
          req = getDataListByCondFq({
            ...this.queryForm,
            searchCond: {
              ...this.queryForm.searchCond,
              onlyParentOtherStages: 1,
              apprStatus: this.queryForm.searchCond.apprStatus == 1 ? '1,5' : this.queryForm.searchCond.apprStatus
            }
          });
        } else if (this.active == 'reject') {
          this.queryForm.searchCond["apprStatus"] = '3';
          req = getDataListByCond({
            ...this.queryForm,
            searchCond: {
              ...this.queryForm.searchCond,
              apprStatus: this.queryForm.searchCond.apprStatus == 1 ? '1,5' : this.queryForm.searchCond.apprStatus
            }
          });
        }
        this.loading = true;
        req.then((res) => {
          this.tableData = res.responseData.modelData;
          this.total = res.responseData.total;
          this.loading = false;
        });
      },
      saveData () {
        this.$refs.hospitalChild.saveData();
      },
      submitConfrim () {
        this.$refs.hospitalChild.submitConfrim();
      },
      back () {
        this.$refs.hospitalChild.back();
      },
      mounted() {
        this.getcheckSimalar()
      },
      //获取子组件传值
      getcheckSimalar(data,val){
        this.checkSimalar = data;
        this.outherInfo=val;
      },
      newChecked(){
        this.checkSimalar="";
        this.outherInfo="";
      },

      //关闭提交页
      closeSubmit(){
        console.log(this.detailData.apprStatus );
        this.queryList();
      },

      // 接收弹窗子组件传过来的新值
      detailDataNew(data) {
        this.detailData = data;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "src/common/common.scss";
  @import "src/common/dialog.scss";
</style>



// WEBPACK FOOTER //
// src/pages/child/hospital/HospitalChildTable.vue